// src/pages/AttributionPage.js
import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import ProductLogo from '../components/ProductLogo';
import Button from '../components/Button';
import styles from './AttributionPage.module.css';
import { sendMessageToParent } from '../utils/postMessage';

const AttributionPage = () => {
  useEffect(() => {
    document.title = 'Instant Attribution - Track Every Customer Touchpoint';
  }, []);

  const handleNavigateClick = () => {
    sendMessageToParent('NAVIGATE_TO', {
      feature: 'attribution',
      redirect: 'https://www.instant.one/products/attribution',
      source: 'attribution_landing_page'
    });
  };

  return (
    <Layout>
      <div className={`page ${styles.attributionPage}`}>
        <section className={styles.heroSection}>
          <div className={styles.container}>
            <div className={styles.heroContent}>
              <div className={`${styles.heroText} half-width`}>
                <div className={styles.iconProductName}>
                    <ProductLogo product={'attribution'} size={32} />
                    <span className={styles.productName}>Instant ATTRIBUTION</span>
                </div>
               <div className={styles.heroTitleContainer}>
                <h1 className={styles.heroTitle}>
                    Gain a clear understanding of the performance and return on every dollar spent.
                    </h1>
                    <p className={styles.heroSubtitle}>
                    Instant provides complete and precise insights into every shopper's conversion, allowing you to focus on your most profitable channels.
                    </p>
               </div>
                <Button onClick={handleNavigateClick}> Request early access </Button>
              </div>
              <div className={`${styles.heroImage} half-width`}>
                {/* <img 
                  src="/images/attribution-hero-image.webp" 
                  alt="Attribution Analytics Preview"
                /> */}
                <video
                  src="/images/attribution-hero-video.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                  alt="Attribution Analytics Preview"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default AttributionPage;